module.exports = __webpack_public_path__ + "assets/img/kefu.4830dc9e.jpg";